import React from 'react';
import { motion } from 'framer-motion';

const WhoItsFor = () => {
  const audience = [
    { icon: "🏢", title: "Business Owners" },
    { icon: "👔", title: "Professionals" },
    { icon: "🎯", title: "Coaches" },
    { icon: "📚", title: "Trainers" },
    { icon: "💼", title: "Consultants" },
    { icon: "💻", title: "Freelancers" },
    { icon: "🏪", title: "Agency Owners" },
    { icon: "🛍️", title: "Local Stores" }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4">
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            Perfect for <span className="gradient-text">Every Business Professional</span> 👥
          </h2>
          <p className="text-lg text-gray-600">
            No matter what you do, these strategies work for everyone
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {audience.map((item, index) => (
            <motion.div
              key={index}
              className="bg-gradient-to-br from-purple-50 to-orange-50 p-6 rounded-2xl text-center card-hover"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.05 }}
              viewport={{ once: true }}
            >
              <div className="text-4xl mb-3">{item.icon}</div>
              <h3 className="font-semibold text-gray-800">{item.title}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoItsFor;